module.exports = __webpack_public_path__ + "static/media/31_CALCINHA_FIO_DUPLO_LISA_02.b4ab7051.jpg";